import React from 'react';
import {useNavigate} from "react-router-dom";


const InfoBodyMerchant = () => {
    const navigate = useNavigate();

    function goToLogin(){
        navigate("/login?link=2");
    }
    return (
        <div className='h-fit w-full bg-slate-200 px-40 mobile:px-0 laptop:px-20'>
            <div className='w-full bg-yellow-100 border-l-4 border-yellow-500 p-4 mb-4'>
                <div className='flex'>
                    <div className='ml-3'>
                        <p className='text-sm text-yellow-700 font-medium'>
                            Хөтөлбөрийн хугацаа дууссан байна. Дараагийн урамшуулалт хөтөлбөр тун удахгүй.
                        </p>
                    </div>
                </div>
            </div>
            {/*<div className='w-full h-full bg-white'>*/}
            {/*    <img src="./images/Happy Merchant AP pos banner.png" className='w-full object-cover mobile:h-40'  alt="banner"/>*/}
            {/*    <div className='w-full h-full px-36 py-10 space-y-8 mobile:px-4 text-justify tablet:px-16'>*/}
            {/*        <p className='font-bold text-xl text-[#0987F3]'>Жижиг дунд бизнес эрхлэгч та ХХБ-ны ПОС дээрээ Apple Pay-ээр дамжуулан*/}
            {/*            ХАМГИЙН ОЛОН ТООГООР ГҮЙЛГЭЭ хийн, урамшууллын эзэн болоорой.</p>*/}
            {/*        <div>*/}

            {/*        </div>*/}
            {/*        <div>*/}
            {/*            <p className='font-bold text-[#0987F3]'>Урамшууллын хугацаа:</p>*/}
            {/*            <p>2025 оны 01-р сарын 01-ний өдрөөс 04-р сарын 01-ний өдрийг хүртэл</p>*/}
            {/*        </div>*/}
            {/*        <div>*/}
            {/*            <p className='font-bold text-[#0987F3]'>Урамшуулал:</p>*/}
            {/*            <ul className='list-disc ml-5'>*/}
            {/*                <li>iPhone 16 - 3 харилцагч</li>*/}
            {/*                <li>IWatch - 3 харилцагч</li>*/}
            {/*                <li>AirPods - 6 харилцагч</li>*/}
            {/*                <li>Эрхийн бичиг /Амралт, сувиллын газар/ - 30 харилцагч</li>*/}
            {/*            </ul>*/}
            {/*        </div>*/}
            {/*        <div>*/}
            {/*            <p className='font-bold text-[#0987F3]'>Урамшууллыг хэрхэн цуглуулах вэ?</p>*/}
            {/*            <p>ХХБ-ны ПОС дээрээ Apple Pay-ээр дамжуулан ХАМГИЙН ОЛОН ТООГООР ГҮЙЛГЭЭ хийсэн тохиолдолд.</p>*/}
            {/*        </div>*/}
            {/*        <div>*/}
            {/*            <p className='font-bold text-[#0987F3]'>Урамшууллын эздийг тодруулах:</p>*/}
            {/*            <ul>*/}
            {/*                <li>*/}
            {/*                    2025.01.01-2025.01.31 /2025.02.15-ны дотор/*/}
            {/*                </li>*/}
            {/*                <li>*/}
            {/*                    2025.02.01-2025.02.28 /2025.03.15-ны дотор/*/}
            {/*                </li>*/}
            {/*                <li>*/}
            {/*                    2025.03.01-2025.03.31 /2025.04.15-ны дотор/*/}
            {/*                </li>*/}
            {/*            </ul>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*        <img src="./images/happy_merchant_2025-3.jpg"  className='w-9/12 block mx-auto object-cover mobile:block mobile:h-40'  alt=""/>*/}
            {/*</div>*/}
        </div>
    );
}

export default InfoBodyMerchant;